<template>
  <div class="generalized-return-page" v-loading="loading">
    <div class="promotion-links">
      <div class="title">我的推广链接:</div>
      <div class="content">
        <div v-if="isAgree">
          <div class="links">{{ links }}</div>
          <el-button
            type="primary"
            class="copy-button"
            @click="copyLink"
            id="link_btn"
            >复制推广链接</el-button
          >
          <el-link
            :underline="false"
            class="promotion-level-desc"
            type="primary"
            @click="dialogShowPromotionLevelExplain = true"
            v-if="promotionLevel != -1"
            >{{ promotionLevelList[promotionLevel].levelTitle }}({{
              promotionLevelList[promotionLevel].returnproportion
            }}%返现)</el-link
          >
        </div>
        <div class="unagree-text" v-else>
          请刷新页面，同意《推广员及代理商管理协议》才能获得推广员或代理商资格。
        </div>
      </div>
    </div>
    <div class="my-commission">
      <div class="title">
        我的佣金
        <div class="title-right" @click="linkToCommission">
          <i class="fa-file-text"></i>
          明细
        </div>
      </div>
      <div class="content">
        <div v-if="isAgree">
          <div class="commission-number">
            ￥{{ numberFormat(commissionInfo.commission) }}
          </div>
          <el-link
            :underline="false"
            type="primary"
            @click="dialogShowCashWithdrawal = true"
            >申请提现</el-link
          >
        </div>
      </div>
    </div>
    <div class="message-list">
      <div class="title">最新消息</div>
      <div class="content">
        <div class="list" v-if="isAgree">
          <div class="item" v-for="(item, index) in messageList" :key="index">
            <div v-if="item.type == 1">
              <span class="user">{{ item.name }}</span>
              打开了您的推广链接
            </div>
            <div v-if="item.type == 2">
              <span class="user">{{ item.name }}</span>
              创建了订单
            </div>
            <div v-if="item.type == 3">
              <span class="user">{{ item.name }}</span>
              购买了"
              <span class="important-text">{{ item.pname }}</span
              >"
            </div>
            <div v-if="item.type == 4">
              <span class="user">{{ item.name }}</span>
              首次激活"
              <span class="important-text">{{ item.pname }}</span
              >",获得
              <span class="important-text"
                >￥{{ fractionFormat(item.money) }}</span
              >
              佣金
            </div>
            <div
              v-if="item.type == 5 && item.money == 0 && promotionLevel == 0"
            >
              <span class="user">{{ item.name }}</span>
              续费"
              <span class="important-text">{{ item.pname }}</span
              >",获得
              <span class="important-text"
                >￥{{ fractionFormat(item.money) }}</span
              >
              佣金，
              <span class="user" @click="dialogShowPromotionLevelExplain = true"
                >成为代理商</span
              >即可获得续费佣金
            </div>
            <div v-if="item.type == 5 && item.money > 0 && promotionLevel == 1">
              <span class="user">{{ item.name }}</span>
              续费"
              <span class="important-text">{{ item.pname }}</span
              >",获得
              <span class="important-text"
                >￥{{ fractionFormat(item.money) }}</span
              >
              佣金
            </div>
            <div v-if="item.type == 6">
              <span class="user">{{ item.name }}</span>
              退款了"
              <span class="important-text">{{ item.pname }}</span
              >",扣除
              <span class="important-text"
                >￥{{ fractionFormat(item.money) }}</span
              >
              佣金
            </div>
            <div v-if="item.type == 7">
              成功提现
              <span class="important-text"
                >￥{{ fractionFormat(item.money) }}</span
              >
              到支付宝
              <span class="user">{{ item.account }}</span>
            </div>
          </div>
          <div class="no-data" v-if="!messageList.length">无记录</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="promotion-level-dialog"
      top="0"
      :width="'80%'"
      :visible.sync="dialogShowPromotionLevelExplain"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">推广等级说明</div>
      <div class="dialog-body">
        <div class="table-header">
          <div class="column-1">等级</div>
          <div class="column-2">返现比例</div>
          <div class="column-3">提现门槛</div>
        </div>
        <ul class="table-body">
          <li
            class="item"
            v-for="item in promotionLevelList"
            :key="item.nickname"
          >
            <div class="column-1">
              <span class="nickname">{{ item.levelTitle }}</span>
            </div>
            <div class="column-2">{{ item.returnproportion }}%</div>
            <div class="column-3">{{ item.requirement }}</div>
          </li>
          <div class="tips">
            <p>
              推广员：通过您购买<b>并使用</b>的 F码，
              只要是<b>新用户激活</b>，您就能获得25% 的返现奖励！
            </p>
            <p>
              代理商：通过您购买<b>并使用</b>的 F码， 不论是<b>新用户激活</b> 或
              <b>老用户续费</b>， 您都能获得30%
              的返现奖励！另外，通过你激活的新用户，在推广关系存续期间，他在后台续费也会自动计入你的佣金。
            </p>
            <p>
              代理商需要交纳 <b>300元</b>的加盟费才能
              成为代理商。成为代理商请加微信：<br />
               xiaohudi999 或 QQ：642158787
            </p>
            <p @click="dialogShowAgreement = true">推广员及代理商管理协议</p>
          </div>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogShowPromotionLevelExplain = false"
          >我知道了</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="cash-withdrawal-dialog"
      :width="'72%'"
      top="10%"
      :visible.sync="dialogShowCashWithdrawal"
      :modal-append-to-body="false"
    >
      <div slot="title" class="dialog-title">提现申请</div>
      <div class="dialog-body">
        <p class="text">支付宝账号:</p>
        <el-input
          placeholder="请输入支付宝账号"
          v-model.trim="aliAccount.paylink"
          clearable
        ></el-input>
        <p class="text">姓名:（转账需要）</p>
        <el-input
          placeholder="请输入支付宝绑定姓名"
          v-model.trim="aliAccount.name"
          clearable
        ></el-input>
        <!-- <p class="text">可提现金额: ￥{{numberFormat(fractionFormat(commissionInfo.canWithdrawableCommission))}}</p> -->
        <p class="text">
          我的佣金: ￥{{ numberFormat(commissionInfo.commission) }}
        </p>
        <el-button type="primary" class="withdrawal-button" @click="applyDraw"
          >申请提现</el-button
        >
        <div class="tips">
          注：周一至周五可申请提现，申请之 后请耐心等待，我们会在<span
            class="important-text"
            >每周日</span
          >给大 家转账。每次申请金额≥
          <span class="important-text">20元</span> 才可 提现
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="agreement-dialog"
      top="0"
      :width="'95%'"
      :visible.sync="dialogShowAgreement"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">用户协议</div>
      <div class="dialog-body">
        <h2>推广员及代理商管理协议</h2>
        <p>
          为了满足小虎弟市场发展需求，现推出推广返现体系，诚邀热爱小虎弟品牌的客户，成为推广员或代理商，共同拓展平台客户市场，双方根据中华人民共和国相关法律法规，本着友好合作、互惠互利、共同发展的原则，双方自愿签订本协议。
        </p>
        <p>
          权利及义务：<br />
          推广员：人人都能成为小虎弟的推广员，通过你推广链接成交的F码都会记录您的推广关系，在用户使用F码之后，会给您进行佣金结算，如果是小虎弟的新用户，则可以获得25%购卡金额的佣金，支持提现！每次提现金额须≥￥20。<br />
          代理商：您需要缴纳300元的加盟费，才能成为小虎弟的代理商，不论是新用户激活还是老用户续费，您都能获得用卡奖励，奖励比例是购卡费用的30%！加盟费作为小虎弟品牌的使用费和管理费，此费用缴纳后不予退还。
        </p>
        <p>
          不论代理商还是推广员，都应遵守以下约定：<br />
          1、推广售卖过程中，售价须与官网保持一致，不得以返利的形式诱导客户成交。<br />
          2、推广售卖过程中，不得中伤抹黑小虎弟品牌<br />
          3、推广售卖过程中，不得恶意退款刷佣金，退款会扣除相应佣金
        </p>
        <p>违反约定的小虎弟有权终止推广员或代理商的资格并罚没佣金。</p>
        <p>
          点击本页面上同意按钮后，表示您已认真阅读及询问，已完全知悉、理解并同意上述内容！
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogShowAgreement = false"
          v-if="isAgree"
          >我知道了</el-button
        >
        <el-button type="info" @click="agreeAgent(0)" v-if="!isAgree"
          >不同意</el-button
        >
        <el-button type="primary" @click="agreeAgent(1)" v-if="!isAgree"
          >同意</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userInfo, getAgentdata, applyDraw, agreeAgent } from "@/api/index";
import Clipboard from "clipboard";
import { amountData } from "@/mixins/amountData";
import { mapActions } from "vuex";
export default {
  mixins: [amountData],
  data() {
    return {
      user: {},
      promotionLevel: -1,
      promotionLevelList: [
        {
          levelTitle: "推广员",
          returnproportion: "25",
          requirement: "20元",
        },
        {
          levelTitle: "代理商",
          returnproportion: "30",
          requirement: "无",
        },
      ],
      commissionInfo: {
        canWithdrawableCommission: 0,
        commission: 0,
      },
      messageList: [
        // {
        //     name: "李小帅",
        //     type: 1,
        //     num: 1,
        //     pname: "电脑版季卡",
        //     money: 28.7,
        //     datetime: 1574133102
        // }
      ],
      dialogShowPromotionLevelExplain: false,
      dialogShowCashWithdrawal: false,
      aliAccount: {
        paylink: "",
        name: "",
      },
      loading: true,
      dialogShowAgreement: false,
      isAgree: false,
    };
  },
  computed: {
    links() {
      return `https://www.xiaohudi.com/?f=${this.user.account}`;
    },
  },
  async created() {
    try {
      //checklogin
      let userinfo = await userInfo();
      let code = userinfo.code;
      if (code == -2050) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: "agent",
          },
        });
      } else {
        this.user = userinfo.data;
      }
    } catch (e) {}
  },
  mounted() {
    this.getAgentdata();
  },
  methods: {
    ...mapActions(["updateAgentType"]),
    getAgentdata() {
      getAgentdata().then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.commissionInfo.commission = this.fractionFormat(data.commission);
          this.commissionInfo.canWithdrawableCommission = this.fractionFormat(
            data.commission
          );
          this.messageList = data.record;
          this.promotionLevel = data.type;
          this.updateAgentType(data.type);
          this.aliAccount.paylink = data.alipay.account;
          this.aliAccount.name = data.alipay.name;
          this.isAgree = data.agreement;
          if (!data.agreement) {
            this.dialogShowAgreement = true;
          }
        }
        this.loading = false;
      });
    },
    agreeAgent(status) {
      agreeAgent({
        status,
      }).then((res) => {
        if (res.code == 0) {
          if (status == 1) {
            this.getAgentdata();
          }
          this.dialogShowAgreement = false;
        }
      });
    },
    applyDraw() {
      if (!this.aliAccount.paylink) {
        this.$message({
          message: "请输入支付宝账号",
          type: "error",
          duration: 2000,
        });
        return;
      }
      if (!this.aliAccount.name) {
        this.$message({
          message: "请输入支付宝绑定姓名",
          type: "error",
          duration: 2000,
        });
        return;
      }
      if (this.promotionLevel == 0) {
        if (this.commissionInfo.commission < 20) {
          this.$message({
            message: "推广员提现金额不能少于20元",
            type: "error",
            duration: 2000,
          });
          return;
        }
      }
      applyDraw(this.aliAccount).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "申请成功",
            type: "success",
            duration: 2000,
          });
          this.dialogShowCashWithdrawal = false;
        } else {
          if (res.code == -1) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>提现失败</strong><p style="margin-top: 5px;">缺少支付宝账号和实名信息</p>',
            });
          }
        }
      });
    },
    copyLink() {
      var clip = new Clipboard("#link_btn", {
        text: () => `给你推荐一个好东西，会赚钱的主播都在用：\n${this.links}`,
      });
      clip.on("success", (e) => {
        this.$message({
          message: "复制成功，快去分享吧！！",
          type: "success",
        });
        e.clearSelection();
        clip.destroy();
      });
      clip.on("error", () => {
        this.$message({
          message: "复制失败！！",
          type: "error",
        });
        clip.destroy();
      });
    },
    linkToCommission() {
      this.$router.push({
        path: "/details",
      });
    },
  },
};
</script>

<style lang="less">
.generalized-return-page {
  .el-dialog__body {
    padding: 10px 20px 15px;
  }
}
</style>

<style lang="less" scoped>
.generalized-return-page {
  height: 100%;
  color: #101010;
  .important-text {
    color: #ffa500;
  }
  .title {
    line-height: 44px;
    padding: 0 16px;
    font-weight: 700;
    font-size: 16px;
    text-align: left;
  }
  .el-link {
    cursor: pointer;
  }
  .content {
    padding: 0 20px 30px;
    font-size: 14px;
  }
  .promotion-links {
    text-align: center;
    height: 191px;
    .links {
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .copy-button {
      display: block;
      margin: 20px auto 14px;
    }
    .unagree-text {
      font-size: 14px;
      line-height: 20px;
      color: #101010;
      text-align: left;
    }
  }
  .my-commission {
    .title {
      display: flex;
      justify-content: space-between;
      background: #f2f2f2;
    }
    .content {
      text-align: center;
      height: 191px;
      padding-top: 29px;
      .commission-number {
        font-size: 72px;
        line-height: 100px;
        margin: 0 0 9px;
      }
    }
  }
  .message-list {
    height: calc(~"100% - 191.6px - 235.2px");
    .title {
      background: #f2f2f2;
    }
    .content {
      height: calc(~"100% - 44px");
      padding: 10px 20px;
      overflow: auto;
      padding-bottom: 60px;
      .list {
        font-size: 14px;
        line-height: 20px;
        .item {
          margin: 4px 0 0;
          .user {
            color: #21a0ff;
          }
        }
      }
    }
  }
  .dialog-title {
    text-align: center;
    font-size: 20px;
  }
  .promotion-level-dialog {
    .dialog-body {
      .column-1 {
        flex: 1;
      }
      .column-2 {
        flex: 1;
        text-align: center;
      }
      .column-3 {
        flex: 1;
        text-align: center;
      }
      .table-header {
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        padding-right: 4px;
        font-weight: 600;
      }
      .table-body {
        .item {
          display: flex;
          justify-content: space-between;
          align-items: stretch;
          height: 24px;
          line-height: 24px;
          font-weight: 500;
        }
        .tips {
          margin-top: 20px;
          padding-top: 10px;
          border-top: 1px solid #bbbbbb;
          color: #101010;
        }
      }
    }
    .dialog-footer {
      text-align: center;
    }
  }
  .cash-withdrawal-dialog {
    .el-input {
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .text {
      font-size: 14px;
      line-height: 24px;
      margin: 0;
      color: #101010;
    }
    .withdrawal-button {
      display: block;
      width: 80%;
      margin: 20px auto 45px;
    }
    .tips {
      padding-top: 20px;
      border-top: 1px solid #bbbbbb;
      color: #a6a6a6;
    }
  }
  .agreement-dialog {
    .dialog-body {
      height: 400px;
      overflow: auto;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}
</style>
